import Controller from '@ember/controller';
import { action, get, set, setProperties } from '@ember/object';
import { service } from '@ember/service';
import logger from 'donor-elf-web/lib/logger';

export default Controller.extend({
  contactsCache: service(),
  fundsService: service(),
  router: service(),
  store: service(),

  checkFundUploadProgress: false,

  reset() {
    setProperties(this, {
      checkFundUploadProgress: false,
    });
  },

  handleS3UploadComplete: action(function (s3Upload) {
    this.fundsService.confirmValidFundToken().then(() => {
      let importRecord = this.store.createRecord('tnt-connect-import', {
        importType: 'datasync',
        s3Key: get(s3Upload, 'key'),
      });
      importRecord.save().then(() => {
        set(this, 'checkFundUploadProgress', true);
      });
    });
  }),

  handleS3UploadError: action(function () {
    logger.error('There was an error uploading the TntConnect XML file');
  }),

  onFundUploadComplete: action(function () {
    this.contactsCache.loadContacts({ forceLoad: true }).then(() => {
      this.router.transitionTo(
        'funds.fund.more.tnt-connect-import.data-sync.complete',
      );
    });
  }),
});
